import React from 'react';
import Icon, { IconProps } from '../Icon';

const NewTabIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.86825 1.2L5.4846 5.58365C5.22727 5.84098 5.2269 6.25924 5.48465 6.51698C5.74187 6.77421 6.16026 6.77475 6.41798 6.51703L10.8 2.13501V3.60047C10.8 3.93088 11.0686 4.2 11.4 4.2C11.7307 4.2 12 3.93158 12 3.60047V0.599526C12 0.434401 11.9329 0.284584 11.8244 0.176015C11.7158 0.0672616 11.5659 0 11.4005 0H8.39953C8.06912 0 7.8 0.268629 7.8 0.6C7.8 0.930697 8.06842 1.2 8.39953 1.2H9.86825ZM12 7.2V4.34777V10.5045C12 11.3304 11.4049 12 10.6699 12H1.33006C0.595488 12 0 11.3291 0 10.5045V1.49555C0 0.669578 0.595082 0 1.33006 0H7.73497H4.8C5.13137 0 5.4 0.268629 5.4 0.6C5.4 0.931371 5.13137 1.2 4.8 1.2H1.54167C1.35079 1.2 1.2 1.37921 1.2 1.60028V10.3997C1.2 10.6168 1.35297 10.8 1.54167 10.8H10.4583C10.6492 10.8 10.8 10.6208 10.8 10.3997V7.2C10.8 6.86863 11.0686 6.6 11.4 6.6C11.7314 6.6 12 6.86863 12 7.2Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </Icon>
  );
};
export default NewTabIcon;
